import type { RootState } from '..';
import type { WidgetTabViewModel } from '../types';
import type { WidgetType } from '@thinkalpha/ui-types/contracts/workspace';

export const getWidgetTabViewModels = (state: RootState): Record<string, WidgetTabViewModel> => state.tab.byId;

export const getWidgetCountByType = (state: RootState, widgetType: WidgetType): number => {
    return Object.values(state.tab.byId).filter((tab) => tab.widget.type === widgetType).length;
};

export const getFirstTabByWidgetType = (state: RootState, widgetType: WidgetType): WidgetTabViewModel | undefined => {
    return Object.values(state.tab.byId).find((tab) => tab.widget.type === widgetType);
};
